<template>
  <div>
    <ErrorManager></ErrorManager>
    <router-view></router-view>
  </div>
</template>

<script>
import ErrorManager from "./components/common/ErrorManager.vue";

export default {
  components: {
    ErrorManager,
  },
};
</script>

<style>
.home {
  font-family: sans-serif;
  --login-main-color: #3f51b5;
  --login-main-bg-color: rgb(129, 173, 255);
}

.grid-center-h-v {
  display: grid;
  place-items: center;
  min-height: 20vh;
  width: 100%;
}

.opacity-unselected {
  opacity: 0.5;
}

/**
 * OVERWRITE upload dropzone (components/home/ClientInfo.vue)
 * the default z-index is 999 it may cause 
 * an unwanted superposition on dialogs
 */
.overwrite-dropzone-index {
  z-index: 1000;
}
</style>
